import { connect } from "react-redux";

import {
  setPrimaryColorObject,
  setSelectionColorObject,
  selectPrimaryColorObject,
  selectSelectionColorObject,
  setStrokeWidth,
  selectStrokeWidth,
  setSelectionStrokeWidth,
  selectSelectionStrokeWidth
} from "~/store/ducks/application/fabric";
import ColorPickerButton from "./ColorPickerButton";

const mapStateToProps = state => ({
  primaryColor: selectPrimaryColorObject(state),
  selectionColor: selectSelectionColorObject(state),
  strokeWidth: selectStrokeWidth(state),
  selectionStrokeWidth: selectSelectionStrokeWidth(state)
});

const mapDispatchToProps = {
  setPrimaryColorObject,
  setSelectionColorObject,
  setStrokeWidth,
  setSelectionStrokeWidth
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorPickerButton);
